import React from 'react';

const activeBg = '/assets/img/userInfoBorder.svg';
const inactiveBg = '/assets/img/avatar-inactive-bg.png';
const def = '/assets/img/user-active.svg';

const UserAvatar = ({
  src,
  rank,
  active = false,
  sex,
  children,
}) => {
  let defaultSrc = '/assets/img/user-active.svg';
  if (sex === 'male') defaultSrc = '/assets/img/male_sex.svg';
  else if (sex === 'female') defaultSrc = '/assets/img/female_sex.svg';
  const finalSrc = src || defaultSrc;

  return (
    <div>
      {/* {rank !== undefined && rank < 3 && (
        <div className="text-center">
          <img
            src={`/assets/img/crown-${rank + 1}.svg`}
            style={{ width: '30px' }}
          />
        </div>
      )} */}
      <div className="square">
        {active !== undefined && (
          <div
            className="img-bg-cover"
            style={{
              backgroundImage: `url(${activeBg})`,
            }}
          ></div>
        )}
        {children ? (
          <div className="pos-abs-center">
            {children}
          </div>
        ) : (
          <div
            className="img-bg-contain"
            style={{ backgroundImage: `url(${finalSrc})`, minWidth: '80%', minHeight: '80%' }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default UserAvatar;
